
import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import PageHeader from "../components/pageHeader";
import { Link, useNavigate } from "react-router-dom";
import debounce from 'lodash.debounce';


const Users = () => {

    const navigate = useNavigate();
    const [userData, setUserData] = useState([]);

    const [userTypeID, setUserType] = useState([]);
    const [userStatusID, setUserStatus] = useState([]);
    
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    const [newdata, setNewdata] = useState({
        userTypeID: 0, userStatusID: 0,
    });
    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };
    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-UserTypeList', setUserType);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindUserStatusList', setUserStatus);
    }, []);

    const fetchDataFiltered = async () => {
        
        fetchData('https://igapi.heuristticminds.com/api/UsersList/Get-GetUsersDetailByTypeStatusID?userTypeID=' + newdata.userTypeID + '&userStatusID=' + newdata.userStatusID, setUserData)
        
    };

    useEffect(() => {
        fetchDataFiltered(); // Fetch filtered data when component mounts
    }, [newdata.userTypeID, newdata.userStatusID]); // Fetch filtered data when dropdown values change

    
    useEffect(() => {
        if (newdata.userTypeID !== 0 || newdata.userStatusID !== 0) { // Only fetch data if userTypeID is selected
            fetchDataFiltered();
        } 
    }, [newdata]);

    // Filter Data based on searchQuery
    useEffect(() => {
        const lowercasedFilter = searchQuery.toLowerCase();
        const filtered = userData.filter(item =>
            item.mobile.toLowerCase().includes(lowercasedFilter) ||
            item.username.toLowerCase().includes(lowercasedFilter) ||
            item.userType.toString().toLowerCase().includes(lowercasedFilter) ||
            item.id.toString().toLowerCase().includes(lowercasedFilter)
        );
        setFilteredData(filtered);
    }, [searchQuery, userData]);
    

    const onChangeHandle = (e) => {
        const { name, value } = e.target;
        setNewdata(prevState => ({
            ...prevState,
            [name]: parseInt(value, 10) // Update the corresponding state based on the dropdown's name
        }));
        // If both dropdowns have been selected, fetch filtered data
        if (name === 'userTypeID' && newdata.userStatusID !== 0) {
            fetchDataFiltered();
        } else if (name === 'userStatusID' && newdata.userTypeID !== 0) {
            fetchDataFiltered();
        }
    };

    // Debounced search handler to avoid excessive re-renders
    const handleSearchChange = debounce((e) => {
        setSearchQuery(e.target.value);
    }, 300);

    const columns = [
        {
            name: "ID",
            selector: row => row.id,
            width: "80px"
        },
        {
            name: "User Name",
            selector: row => row.username,
            sortable: true,
            width: "170px",
            wrap: true,
        },
        {
            name: "Contact",
            selector: row => (
                <>
                    {row.email} <br /> {row.mobile}
                </>
            ),
            width: "200px"
        },
        {
            name: "Role",
            selector: (row) => row.userType,
            width: "80px"
        },
        {
            name: "Joined On",
            selector: (row) => new Date(row.createdOn).toLocaleDateString('en-GB',{day: 'numeric', month: 'numeric', year: 'numeric'}),
            width: "100px"
        },
        {
            name: "Remarks",
            selector: (row) => row.remarks,
            width: "200px",
            wrap: true,
        },
       {
        name: "Status",
            cell: (row) => (
                <div>
                    <Link to={``} onClick={() => onStatusClick(row.id)}>
                        <img
                            src={row.status === 1 ? "/images/ImgActive.gif" : row.status === 2 ? "/images/ImgInActive.gif" : "/images/ImgEdit.ico"}
                            alt="Change Status"
                            title="Change Status"
                            style={{ width: "50px", height: "25px" }}
                        />
                    </Link>
                </div>
            ),
            maxWidth:"80px",
        },
        {
            name: "Action",
            cell: (row) => (
                <>
                    <button style={{ width: "100px" }} className={`btn m-1 tp ${
                         (row.addStatus === 0 &&  row.aboutStatus === 0) ? 'btn-primary' : 
                         (row.addStatus > 0 && row.aboutStatus > 0) ? 'btn-success' : 'btn-warning'                        
                        }`} onClick={(event) => onClickProfile(event, row.id, row.userType_id)}>
                            <span className="tptitle">
                                {
                                    (row.addStatus === 0 && row.aboutStatus === 0) ? 'Add Profile' : 
                                    (row.addStatus > 0 && row.aboutStatus > 0) ? 'Edit Profile' : 'Edit Profile'                        
                                }
                            </span>
                            <small>
                                {
                                    (row.addStatus === 0 && row.aboutStatus === 0) ? 'Add Profile' : 
                                    (row.addStatus > 0 && row.aboutStatus > 0) ? 'Edit Profile' : 'Edit Profile'                        
                                }
                            
                            </small>
                    </button>
                    <div>
                    <Link to={``} onClick={() => onResetClick(row.id)}>
                        <img
                            src={"/images/ImgResetPassword.png"}
                            alt="Reset Password"
                            title="Reset Password"
                            style={{ width: "30px", height: "25px" }}
                        />
                    </Link>
                </div>
                    
                </>
                
            )
            
        },
    ];

    const onStatusClick = async(id) =>{        
        alert(id);
    };

    const onResetClick = async(id) =>{        
        alert(id);
    };

    const onClickProfile = async (event, id, userType_id) =>{
        
        event.preventDefault(); // Prevents the default behavior of the link
    
        // Determine the path based on the userType_id
        const path = userType_id === 2 ? `/addProfileArtist/${id}` : `/addProfileUser/${id}`;
        
        // Navigate to the determined path
        navigate(path);
    };

    return (
        <div>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <div>
                        
                        <PageHeader name='All Users' icon='bi bi-people-fill' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">List Of Users</div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-3">
                                                
                                                <select value={newdata.userTypeID}
                                                        onChange={onChangeHandle}
                                                        name="userTypeID"
                                                        className="form-control form-select">
                                                        <option value={0}>--Select User Type--</option>
                                                        {
                                                            userTypeID.map((utype) => (
                                                                <option key={utype.id} value={utype.id}>
                                                                    {utype.userType}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-sm-3">
                                                    
                                                    <select value={newdata.userStatusID}
                                                        onChange={onChangeHandle}
                                                        name="userStatusID"
                                                        className="form-control form-select">
                                                        <option value={0}>--Select User Status--</option>
                                                        {
                                                            userStatusID.map((ustatus) => (
                                                                <option key={ustatus.id} value={ustatus.id}>
                                                                    {ustatus.statusType}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-sm-3">
                                                <input type="text" name="search" onChange={handleSearchChange} className="form-control" placeholder="Text Search" />
                                                </div>
                                            </div>

                                            <DataTable
                                                columns={columns}
                                                data={filteredData}
                                                pagination
                                                                                            
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    )
}

export default Users;